import {
  // FIND_NOTIFICATION_PREFERENCES_BY_USER_ID,
  PROFILE_PAGE,
  //   MUTATION_CHANGE_PASSWORD,
  MUTATION_UPDATE_USER,
  MUTATION_CHANGE_PASSWORD,
  FIND_USER_BY_ID_V5,
  //   MUTATION_CHANGE_PASSWORD,
} from '@edwin-group/cj-graphql';
import { initializeApollo } from '../lib/apollo-client';
import requestHandler from '../requestHandler';
import type {
  ChangePasswordMutationVariables,
  //   ChangePasswordMutation,
  //   ChangePasswordMutationVariables,
  FindUsersPermissionsUserByIdQuery,
  FindUsersPermissionsUserByIdQueryVariables,
  // GetNotificaitonPreferencesByUserIdQuery,
  // GetNotificaitonPreferencesByUserIdQueryVariables,
  ProfilePage,
  ProfilePageQuery,
  ProfilePageQueryVariables,
  UpdateUsersPermissionsUserMutation,
  UpdateUsersPermissionsUserMutationVariables,
  //   UpdateUserMutation,
  //   UpdateUserMutationVariables,
  UsersPermissionsUser,
  UsersPermissionsUserInput,
} from '@edwin-group/cj-graphql/generated/graphql';

import { getAuthentication } from '@/hooks/useAuthentication';
import { ChangePasswordMutation } from '@/graphql/generated/graphql';

export const getUserById = async () => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<FindUsersPermissionsUserByIdQuery, FindUsersPermissionsUserByIdQueryVariables>({
      query: FIND_USER_BY_ID_V5,
      variables: { documentId: getAuthentication()?.user?.documentId || '' },
    }),
  );

  return {
    user: data?.usersPermissionsUser?.data as UsersPermissionsUser,
    error,
  };
};

// export const getNotificationPreferencesByUserId = async () => {
//   const apolloClient = initializeApollo();

//   const { data, error } = await requestHandler(
//     apolloClient.query<GetNotificaitonPreferencesByUserIdQuery, GetNotificaitonPreferencesByUserIdQueryVariables>({
//       query: FIND_NOTIFICATION_PREFERENCES_BY_USER_ID,
//       variables: { userId: getAuthentication()?.user?.id },
//     }),
//   );

//   return {
//     notificationEntityId: data?.notificationPreferences?.data?.[0].id,
//     preferences: data?.notificationPreferences?.data?.[0].attributes?.preferences,
//     error,
//   };
// };

export const updateUser = async (id: string, input: UsersPermissionsUserInput) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.mutate<UpdateUsersPermissionsUserMutation, UpdateUsersPermissionsUserMutationVariables>({
      mutation: MUTATION_UPDATE_USER,
      variables: {
        id,
        input,
      },
    }),
  );

  return {
    data,
    error,
  };
};

export const updatePassword = async ({
  currentPassword,
  password,
  passwordConfirmation,
}: {
  currentPassword: string;
  password: string;
  passwordConfirmation: string;
}) => {
  const apolloClient = initializeApollo();
  const { data, error } = await requestHandler(
    apolloClient.mutate<ChangePasswordMutation, ChangePasswordMutationVariables>({
      mutation: MUTATION_CHANGE_PASSWORD,
      variables: {
        currentPassword,
        password,
        passwordConfirmation,
      },
    }),
  );

  return {
    data,
    error,
  };
};

export const getPage = async () => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<ProfilePageQuery, ProfilePageQueryVariables>({
      query: PROFILE_PAGE,
    }),
  );

  return {
    page: data?.profilePage?.data?.attributes as ProfilePage,
    error,
  };
};
